import React from 'react'
import FacebookIcon from '@material-ui/icons/Facebook';

class About extends React.Component {
    constructor() {
        super()
        this.state = {}
    }
    componentDidMount() {
        const headerElem = document.getElementById('header');
        if (headerElem) {
            this.setState({ height: window.innerHeight - headerElem.offsetHeight })
        }
    }
    render() {
        return (
            <div style={{ padding: '2.5rem', lineHeight: '2.5rem', overflow: 'scroll', height: `${this.state.height}px` }}>
                <div>
<div>
                    <a href="https://m.facebook.com/profile.php?id=1239860646159787&ref=content_filter"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="דף הפייסבוק של מהפח">
                        <FacebookIcon fontSize="large"></FacebookIcon>
                    </a></div>
                    <div>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf9Qj_TWR_HlYghuoIVZW3HuXhvL-3b0CT-fdSyLmcrXJttcQ/viewform"
                        target="_blank"
                        rel="noopener noreferrer">דף רישום</a>
                        </div>
                </div>

                <div>
                    <p>
                        <b>מהפח</b> היא יוזמה לשינוי מציאות מתסכלת במעיינות, נחלים ומקומות פתוחים לכל, אהובים וחינמיים בטבע שנוטים להיות מלוכלכים. באמצעות הירתמות של אנשים שאכפת
                להם ועבודה שיטתית לאורך זמן של מהפחנים, המקומות הנבחרים זוכים להבראה: ממקומות מוזנחים ומלוכלכים, הם הופכים לנקיים ומטופלים וציבור המבקרים לומד לכבד
            ולשמור עליהם.</p>
                    <p>
                        <b>אפליקצית מהפח </b>
                        נוצרה באדיבות חברת &quot;תובנות&quot; ובתרומת קרן של&quot;י והיא חלק ממכלול הפעולות של מהפח, שתכליתן ליצור רשת חברתית ארצית למען נקיון הטבע.
                       האפליקציה מאפשרת לכל אדם לחולל מהפכה באחד או יותר מהמקומות שהוא מבקר בהם בטבע באמצעות מנגנון דיווח שהוא גם משחק. מי שמשאיר אחריו מקום מצוחצח
                       – תמונתו מפארת את נעץ המקום באפליקציה ותישאר שם כל עוד המקום נקי או עד שיתקבל עדכון חדש. האפליקציה מאפשרת גם לדווח על מקום שאינו נקי ותסייע להפנות
            לשם את מי שרוצה להשפיע ולנקות.</p>
                    <p>
                        <u>משמעות הצבע של הנעצים:</u>
                        ירוק – עדכון חדש / כחול – חלף שבוע מעדכון / צהוב – חלפו 13 ימים מעדכון / אדום – חלפו 18 ימים מעדכון / אפור – לא עודכן לאחרונה
                    הירשמו לקהילה (קישור לטופס פרטים אישיים) התקשרו 052-4231476 , שלחו מייל והחשוב מכל - צאו לטבע ועשו טוב !</p>

                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom:'2rem' }}>
                    <div style={{ backgroundImage: 'url(/static/wide_logo_sheli-min.png)', backgroundSize: 'contain', height: '8rem', flex: 1, margin: '1rem', backgroundRepeat: 'no-repeat' }}></div>
                    <div style={{ backgroundImage: 'url(/static/color_logo.png)', backgroundSize: 'contain', height: '8rem', flex: 1, margin: '1rem', backgroundRepeat: 'no-repeat' }}></div>
                </div>
            </div>
        );
    }

}

export default About